module.exports = __webpack_public_path__ + "static/media/warn.33d2db6b.svg";